import React from 'react'

function Footer() {
    return (
        <div>
            <footer className='footer'>
                Made with love by Deepak Prasad
            </footer>
        </div>
    )
}

export default Footer
